/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const move = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 6.75H8.833A2.333 2.333 0 0 0 6.5 9.083M15 6.75l-1.867-1.867M15 6.75l-1.867 1.867m-1.866-4.934a.933.933 0 0 0-.934-.933h-8.4A.933.933 0 0 0 1 3.683v8.634a.933.933 0 0 0 .933.933h8.4a.933.933 0 0 0 .934-.933V9.75"
    />
  </svg>
)
export default move
